import React, { useMemo } from "react";
import StandingsTable from "./StandingsTable";
import { EmptyState } from "../../../../components/shared/loading";
import { Trophy, Calendar } from "lucide-react";

const StandingsView = ({
  standings,
  loading,
  error,
  onRetry,
  seasons = [],
  selectedLeague,
  selectedSeason,
  onSeasonChange
}) => {
  const seasonOptions = useMemo(() => {
    return seasons.map(s => ({ value: s, label: s.toString() }));
  }, [seasons]);

  const showEmptyState = !selectedLeague || (!loading && (!standings || standings.length === 0));

  return (
    <div className="space-y-4">
      {/* Season Filter Section */}
      <div className="border border-white/10 rounded-sm p-4 bg-white/[0.02]">
        <div className="max-w-xs">
          <label className="block text-xs font-mono uppercase tracking-widest text-white/60 mb-2">
            Season
          </label>
          <div className="relative">
            <select
              value={selectedSeason}
              onChange={(e) => onSeasonChange(e.target.value)}
              className="w-full px-3 py-2 bg-black border border-white/10 text-white text-sm
                       focus:outline-none focus:border-white/30 transition-colors
                       appearance-none cursor-pointer"
            >
              {seasonOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40 pointer-events-none" />
          </div>
        </div>
      </div>

      {/* Content Section */}
      {loading ? (
        <div className="border border-white/10 rounded-sm p-6 bg-white/[0.02]">
          <p className="text-white/70 text-center">Loading standings...</p>
        </div>
      ) : error ? (
        <EmptyState
          title="Failed to load standings"
          description={error}
          action={
            <button
              onClick={onRetry}
              className="px-4 py-2 bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 hover:bg-emerald-500/30 transition-colors"
            >
              Try Again
            </button>
          }
        />
      ) : showEmptyState ? (
        <EmptyState
          title="No standings data available"
          description="Select a league from the filters above to view standings"
        />
      ) : (
        <div className="border border-white/10 rounded-sm overflow-hidden bg-white/[0.02]">
          <div className="p-6 border-b border-white/10">
            <h2 className="text-xl font-mono uppercase tracking-widest text-white flex items-center gap-3">
              <Trophy className="text-white/60" size={20} />
              League Standings
            </h2>
          </div>
          <div className="p-6">
            <StandingsTable standings={standings} />
          </div>
        </div>
      )}
    </div>
  );
};

export default StandingsView;
